import {
  GET_SALESFORCE_DESCRIBE_REQUEST,
  GET_SALESFORCE_DESCRIBE_SUCCESS,
  GET_SALESFORCE_DESCRIBE_FAILURE,
  GET_SALESFORCE_PREVIEW_REQUEST,
  GET_SALESFORCE_PREVIEW_SUCCESS,
  GET_SALESFORCE_PREVIEW_FAILURE,
  GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE,
  GET_SALESFORCE_USERINFO_REQUEST,
  GET_SALESFORCE_USERINFO_SUCCESS,
  GET_SALESFORCE_USERINFO_FAILURE,
  POST_SALESFORCE_REVOKE_REQUEST,
  POST_SALESFORCE_REVOKE_SUCCESS,
  POST_SALESFORCE_REVOKE_FAILURE,
  GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS,
  POST_SALESFORCE_SYNC_REQUEST,
  POST_SALESFORCE_SYNC_SUCCESS,
  POST_SALESFORCE_SYNC_FAILURE,
  GET_SALESFORCE_LISTVIEWS_REQUEST,
  GET_SALESFORCE_LISTVIEWS_SUCCESS,
  GET_SALESFORCE_LISTVIEWS_FAILURE,
  POST_SALESFORCE_CONFIG_REQUEST,
  POST_SALESFORCE_CONFIG_SUCCESS,
  POST_SALESFORCE_CONFIG_FAILURE,
  GET_SALESFORCE_CONFIG_REQUEST,
  GET_SALESFORCE_CONFIG_SUCCESS,
  GET_SALESFORCE_CONFIG_FAILURE,
  GET_SALESFORCE_IMPORT_HISTORIES_REQUEST,
  GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS,
  GET_SALESFORCE_IMPORT_HISTORIES_FAILURE,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE,
  GET_SALESFORCE_EXPORT_HISTORIES_REQUEST,
  GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS,
  GET_SALESFORCE_EXPORT_HISTORIES_FAILURE,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE,
  LOG_OUT_SUCCESS,
  INITIALIZE_MESSAGE,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
import * as messages from "../../constants/Messages";
import { formatErrorMessage } from "../../utils/utils";
import { HTTP_400_BAD_REQUEST_CODE } from "../../constants/HttpStatusCode";
const { OrderedMap } = require("immutable");

const initialState = {
  salesforce_integration_setting_id: null,
  sobject_name: 0,
  curr_sobject_name: 0,
  isLoadingFields: false,
  fields: {},
  isLoadingPreview: false,
  preview: [],
  errorMessage: "",
  shortMessage: "",
  successMessage: "",
  isImporting: false,
  loadingPreviewFailed: false,
  mapping: {},
  isLoadingSalesforceUserInfo: false,
  salesforceUserName: "",
  isRevoking: false,
  lastUpdate: null,
  syncCount: 0,
  expiredAccessError: false,
  isLoadingListviews: false,
  listviews: [],
  isConfiguring: false,
  enableExport: false,
  exe_export_mappings_flag: false,
  address_import_mappings_flag: false,
  timeline_status_export_mappings_flag: false,
  isLoadingConfig: false,
  isLoadingImportHistories: false,
  salesforceImportHistories: OrderedMap({}),
  pageInfo_importHistories: null,
  isLoadingExportHistories: false,
  salesforceExportHistories: OrderedMap({}),
  pageInfo_exportHistories: null,
  isLoadingImportHistory: false,
  importHistory: null,
  exportHistory: null,
  isLoadingExportHistory: false,
};

const isExpiredAccessError = (error) => {
  return (
    error &&
    error.status === HTTP_400_BAD_REQUEST_CODE &&
    typeof error.data.message === "object" &&
    error.data.message["error"] === "invalid_grant"
  );
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
    syncCount: 0,
    loadingPreviewFailed: false,
  };

  let fields, list;

  switch (action.type) {
    case GET_SALESFORCE_DESCRIBE_REQUEST:
      return {
        ...state,
        isLoadingFields: true,
        expiredAccessError: false,
        curr_sobject_name: action.payload.sobject_name,
      };
    case GET_SALESFORCE_DESCRIBE_SUCCESS:
      if (state.curr_sobject_name === action.payload.sobject_name) {
        fields = {};
        Object.values(action.payload.fields.fields).forEach(
          (item) => (fields[item.name] = item)
        );
        return {
          ...state,
          expiredAccessError: false,
          isLoadingFields: false,
          fields: fields,
        };
      } else {
        return state;
      }
    case GET_SALESFORCE_DESCRIBE_FAILURE:
      return {
        ...state,
        isLoadingFields: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_DESCRIBE_FAILURE
          ),
      };
    case GET_SALESFORCE_PREVIEW_REQUEST:
      return {
        ...state,
        isLoadingPreview: true,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_PREVIEW_SUCCESS:
      return {
        ...state,
        preview: action.payload.data,
        isLoadingPreview: false,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_PREVIEW_FAILURE:
      return {
        ...state,
        isLoadingPreview: false,
        loadingPreviewFailed: true,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_PREVIEW_FAILURE
          ),
      };
    case POST_SALESFORCE_SYNC_REQUEST:
      return {
        ...state,
        isImporting: true,
        expiredAccessError: false,
      };
    case POST_SALESFORCE_SYNC_SUCCESS:
      return {
        ...state,
        isImporting: false,
        expiredAccessError: false,
        message: action.payload.message,
        syncCount: action.payload.data ? action.payload.data.update_count : 0,
      };
    case POST_SALESFORCE_SYNC_FAILURE:
      return {
        ...state,
        isImporting: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_POST_SALESFORCE_SYNC_FAILURE
          ),
      };
    case GET_SALESFORCE_USERINFO_REQUEST:
      return {
        ...state,
        isLoadingSalesforceUserInfo: true,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_USERINFO_SUCCESS:
      return {
        ...state,
        isLoadingSalesforceUserInfo: false,
        expiredAccessError: false,
        salesforceUserName: action.payload.data.name
          ? action.payload.data.name
          : "",
      };
    case GET_SALESFORCE_USERINFO_FAILURE:
      return {
        ...state,
        isLoadingSalesforceUserInfo: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST:
      return {
        ...state,
        isLoadingMapping: true,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_CONFIG_REQUEST:
      return {
        ...state,
        isLoadingConfig: true,
        salesforce_integration_setting_id:
          initialState.salesforce_integration_setting_id,
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS:
      fields = {};
      Object.values(action.payload.fields.fields).forEach(
        (item) => (fields[item.name] = item)
      );
      return {
        ...state,
        salesforce_integration_setting_id: action.payload
          .salesforce_integration_setting_id
          ? action.payload.salesforce_integration_setting_id
          : null,
        isLoadingMapping: false,
        sobject_name: action.payload.sobject_name,
        listview_id: action.payload.listview_id,
        listviews: action.payload.listviews.filter(
          (item) => item.soqlCompatible
        ),
        mapping: action.payload.mapping,
        fields: fields,
        preview: action.payload.preview,
        enableExport: !!action.payload.export_flag,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_CONFIG_SUCCESS:
      return {
        ...state,
        isLoadingConfig: false,
        salesforce_integration_setting_id:
          action.payload.salesforce_integration_setting_id,
        address_import_mappings_flag:
          action.payload.address_import_mappings_flag,
        exe_export_mappings_flag: action.payload.exe_export_mappings_flag,
        timeline_status_export_mappings_flag: action.payload.timeline_status_export_mappings_flag,
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE:
      return {
        ...state,
        isLoadingMapping: false,
        mapping: initialState.mapping,
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case GET_SALESFORCE_CONFIG_FAILURE:
      return {
        ...state,
        isLoadingConfig: false,
        shortMessage:
          "Salesforce連携機能を利用するには、自社リストとキーマンデータベースの少なくとも一方を設定してください。",
      };
    case POST_SALESFORCE_REVOKE_REQUEST:
      return {
        ...state,
        isRevoking: true,
      };
    case POST_SALESFORCE_REVOKE_SUCCESS:
      return {
        ...initialState,
        isRevoking: false,
        message: messages.REVOKE_SUCCESS,
      };
    case POST_SALESFORCE_REVOKE_FAILURE:
      return {
        ...state,
        isRevoking: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_POST_SALESFORCE_REVOKE_FAILURE
        ),
      };
    case GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS:
      return {
        ...state,
        lastUpdate: action.payload.data.instructed_at,
      };
    case GET_SALESFORCE_LISTVIEWS_REQUEST:
      return {
        ...state,
        isLoadingListviews: true,
        listviews: [],
        curr_sobject_name: action.payload.sobject_name,
      };
    case GET_SALESFORCE_LISTVIEWS_SUCCESS:
      if (state.curr_sobject_name === action.payload.sobject_name) {
        return {
          ...state,
          isLoadingListviews: false,
          listviews: action.payload.listviews.filter(
            (item) => item.soqlCompatible
          ),
        };
      } else {
        return state;
      }
    case GET_SALESFORCE_LISTVIEWS_FAILURE:
      return {
        ...state,
        isLoadingListviews: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_LISTVIEWS_FAILURE
          ),
      };
    case POST_SALESFORCE_CONFIG_REQUEST:
      return {
        ...state,
        isConfiguring: true,
      };
    case POST_SALESFORCE_CONFIG_SUCCESS:
      return {
        ...state,
        isConfiguring: false,
      };
    case POST_SALESFORCE_CONFIG_FAILURE:
      return {
        ...state,
        isConfiguring: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_POST_SALESFORCE_CONFIG_FAILURE
        ),
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_REQUEST:
      return {
        ...state,
        isLoadingImportHistories: true,
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS:
      list = OrderedMap({});
      action.payload.data.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        isLoadingImportHistories: false,
        salesforceImportHistories: list,
        pageInfo_importHistories: action.payload.pageInfo,
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_FAILURE:
      return {
        ...state,
        isLoadingImportHistories: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_REQUEST:
      return {
        ...state,
        isLoadingExportHistories: true,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS:
      list = OrderedMap({});
      action.payload.data.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        isLoadingExportHistories: false,
        salesforceExportHistories: list,
        pageInfo_exportHistories: action.payload.pageInfo,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_FAILURE:
      return {
        ...state,
        isLoadingExportHistories: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingImportHistory: true,
        importHistory: null,
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingImportHistory: false,
        importHistory: action.payload.data,
      };
    case GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE:
      return {
        ...state,
        isLoadingImportHistory: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
        importHistory: null,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingExportHistory: true,
        exportHistory: null,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingExportHistory: false,
        exportHistory: action.payload.data,
      };
    case GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE:
      return {
        ...state,
        isLoadingExportHistory: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
        exportHistory: null,
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    case INITIALIZE_MESSAGE:
      return {
        ...state,
        message: initialState.message,
        errorMessage: initialState.errorMessage,
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/salesforce.js